function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AccountContactDetailCtrl = function AccountContactDetailCtrl($state, ContactService, ViewModelService, $rootScope) {
    _classCallCheck(this, AccountContactDetailCtrl);

    this.getAccountDetails = getAccountDetails;
    var sourceStateName = $state.current.data.sourceState;
    this.sourceState = $state.get(sourceStateName);
    this.sourceStateLabel = this.sourceState.data.label;
    function getAccountDetails() {
        var _this = this;

        return ContactService.getAccountContactDetails($rootScope.contactPublicId).then(function (contact) {
            _this.contactModel = ViewModelService.create(contact, 'pc', 'edge.capabilities.gateway.contact.dto.AccountContactDetailsDTO');
        }).catch(function (err) {
            console.log('inside error');
            console.error(err);
            $state.go('gatewayLanding');
        });
    }

    this.accountDetailsPromise = this.getAccountDetails();
};

AccountContactDetailCtrl.$inject = ['$state', 'ContactService', 'ViewModelService', '$rootScope'];
export default AccountContactDetailCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/controllers/AccountContactDetailCtrl.js
// module id = 1655
// module chunks = 0